module.exports = __webpack_public_path__ + "img/icon_map_1_on_111.30c2cee7.png";